export const painSliderCopyFr = {
    scoringHint:
        "Fiez-vous à votre première impression - choisissez le chiffre qui correspond à ce que vous ressentez en ce moment. Inutile d'y réfléchir trop longtemps.",
};
